// extracted by mini-css-extract-plugin
module.exports =  {"indicator":"ScrollingIndicator-module__indicator--N_R2L","shadedArea":"ScrollingIndicator-module__shadedArea--AAS0t"};